import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Swal from "sweetalert2"
import axios from 'axios'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {Spanish} from 'flatpickr/dist/l10n/es.js'

import globalFunctions from '@/functions/globalFunctions'

window.apiKS = process.env.VUE_APP_API_URL

window.Swal = Swal
window.axios = axios
window.flatPickr = flatPickr
window.SpanishFlatPickr = Spanish
// window.hostname = 'porcelana.esaky.mx'
window.hostname = location.hostname

createApp(App).use(store).use(router).mixin(globalFunctions).mount('#app')
